import * as React from "react"
import { useSelector } from "react-redux"
import * as AppTypes from "AppTypes"
import { updateLanguageAATagging, updateAATagging } from "../utils/aatagging"
import DOMPurify from "dompurify"

const Complete = () => {
    const { langPack, userInfo } = useSelector((store: AppTypes.ReducerState) => ({
        langPack: store.config.langPack,
        userInfo: store.userInfo,
    }))
    const { activeCountry } = userInfo;

    React.useEffect(() => {

        let app: HTMLElement = document.getElementsByClassName("view")[0] as HTMLElement;
        const imgName = `thankYouPageImage${activeCountry}`
        const img = langPack[imgName] && langPack[imgName] !== "" ? langPack[imgName] : "bg-complete.png"
        app.style.backgroundImage = `url(images/${img})`;

        setTimeout(() => {
            // AA Tracking
            const AALang = updateLanguageAATagging(langPack["lang"])
            updateAATagging({
                "event_name": "generic_form_submit",
                "form_name": "UOB PoY",
                "submission_id": userInfo.appId,
                "language": AALang,
                "country": userInfo.activeCountry.toLowerCase()
            }, "other_form_submit")
        }, 1000);
    }, [])
    const logoImgName = `thankYouLogo${activeCountry}`
    const logoImg = langPack[logoImgName] && langPack[logoImgName] !== "" ? langPack[logoImgName] : "uob-Logo-blue.png"
    return (
        <React.Fragment>
            <div className="thankYou-logo">
                <img alt="logo" src={`images/${logoImg}`} className="logo-completion" />
                <img alt="logo" src={`images/UOB-group-sealmark-logo.png`} className="right-logo-completion" />
            </div>
            <div className="completion-container">
                <div className="completion-container__header" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(langPack["submittedSuccessfully"]) }} />
                <div className="completion-container__sub-header" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(langPack["thankyou"]) }} />
                <div className="completion-container__sub-header" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(langPack["submittedSuccessNotice"]) }} />
            </div>

        </React.Fragment >
    )
}

export default Complete
